<template>
    <!-- ownership info updates -->

    <div class="module-checkout">
        <div class="checkDetail">
            <h2>Please confirm you are the listed, Trademark Applicant. You can update the Applicant address if necessary<Popper>
                        <span class="GetHelpItem">
                            <span class="popover-icon">
                                <i class="fa fa-question-circle" aria-hidden="true"></i>
                            </span>
                            Get Help
                        </span>
                    <template #content>
                        <div class="popper-content">
                            <b>Who is the trademark owner?</b>
                            <p>The owner of a trademark should be the person or entity that is providing goods or services for sale. If you do business through an LLC or incorporation, the company is usually the proper owner.</p>
                            <b>Still need help?</b>
                            <b>Call customer service at <span>1-833-863-5483</span></b>
                        </div>
                    </template>
                </Popper>
            </h2>
            <div class="inputSec">
                <template v-for="(owner, index) in owners">
                    <div style="border: solid 1px #000; padding: 20px 20px">
                        <h5 style="padding-bottom:5px; font-weight:bold;">{{ owner.party_name }}</h5>
                        <div>{{ level_1(owner) }}</div>
                        <div>{{ level_2(owner) }}
                        </div>
                        <div style="text-align:right">
                            <template v-if="owners.length > 1">
                                <a @click.prevent="deleteOwner(index)" id="masterBody_ucOwners_rptOwners_linkDeleteOwner_0" href="#" style="text-decoration:underline; font-size:11px;"><i class="fa fa-trash" aria-hidden="true"></i> Delete it</a>
                                &nbsp;|&nbsp;
                            </template>
                            <a @click.prevent="edit(index)" id="masterBody_ucOwners_rptOwners_linkUpdateOwner_0" href="#" style="text-decoration:underline; font-size:11px;">Update Address</a>
                            &nbsp;
                        </div>
                        <span class="clear"></span>
                    </div>
                    <div style="height:20px;"></div>
                </template>

            </div>
        </div>
    </div>

    <Popup v-model="showModal">
        <div class="modal-content">
            <div class="modal-body modal-body-main">
                <input type="hidden" v-model="work_owner.party_name" />
                <input type="hidden" v-model="work_owner.entity_type" />

                <div class="form-row md-form">
                    <div class="form-group col-md-6">
                        <InputElement
                            v-model="work_owner.address_1"
                            label="Address 1"
                            :is_error="!work_owner.address_1 && run_valid"
                            text_error="Address is required."
                        ></InputElement>
                    </div>
                    <div class="form-group col-md-6">
                        <InputElement
                            v-model="work_owner.address_2"
                            label="Address 2"
                        ></InputElement>
                    </div>
                </div>

                <div class="form-row md-form">
                    <div class="form-group col-md-4">
                        <InputElement
                            v-model="work_owner.city"
                            label="City"
                            :is_error="!work_owner.city && run_valid"
                            text_error="City is required."
                        ></InputElement>
                    </div>
                    <div class="form-group col-md-4">
                        <InputElement
                            v-model="work_owner.state"
                            label="State/Province"
                        ></InputElement>
                    </div>
                    <div class="form-group col-md-4">
                        <InputElement
                            v-model="work_owner.zip"
                            label="Zip/Postal Code"
                        ></InputElement>
                    </div>
                </div>
                <div class="form-row md-form">
                    <div class="form-group col-md-6 default-f">
                        <Select
                            v-model="work_owner.country"
                            label="Choose Country"
                            :items="countries"
                        ></Select>
                    </div>
                    <div class="form-group col-md-6 default-f">
                        <Select
                            v-model="work_owner.citizenship"
                            label="Choose Citizenship"
                            :items="countries"
                            :is_error="!work_owner.citizenship && run_valid"
                            text_error="Citizenship is required"
                        ></Select>
                    </div><input type="hidden" name="ctl00$masterBody$ucOwners$hiddenAction" id="masterBody_ucOwners_hiddenAction" value="1">
                </div>
                <p class="gray small-font" style="margin-top:18px;">
                    <b>Note:</b> Please note, we will charge $175.00
                    to update the owner information with the federal trademark office.
                </p>
            </div>
            <div class="modal-footer">
                <button @click.prevent="showModal = false" class="modal-footer__button button-next MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedFocus.90 MuiButton-sizeMedium MuiButton-containedSizeMedium MuiButton-disableElevation MuiButton-fullWidth MuiButton-root MuiButton-contained MuiButton-containedFocus.90 MuiButton-sizeMedium MuiButton-containedSizeMedium MuiButton-disableElevation MuiButton-fullWidth button-bottom" tabindex="0" type="button" role="button" data-testid="screen-next">Cancel</button>
                <button @click.prevent="update" class="modal-footer__button button-next MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedFocus.90 MuiButton-sizeMedium MuiButton-containedSizeMedium MuiButton-disableElevation MuiButton-fullWidth MuiButton-root MuiButton-contained MuiButton-containedFocus.90 MuiButton-sizeMedium MuiButton-containedSizeMedium MuiButton-disableElevation MuiButton-fullWidth button-bottom" tabindex="0" type="button" role="button" data-testid="screen-next">Save Changes</button>
            </div>
        </div>
    </Popup>

</template>

<script>
import Popup from '@/components/Popup.vue'
import InputElement from "@/ui/Input-Textarea";
import Select from "@/ui/Select";

export default {
    components: {
        Popup,
        InputElement,
        Select
    },
    props: {
        start_owners: Array
    },
    data() {
        return {
            owners: this.start_owners,
            showModal: false,
            run_valid: false,
            countries: {
                AF: "AFGHANISTAN",
                AL: "ALBANIA",
                DZ: "ALGERIA",
                AS: "AMERICAN SAMOA",
                AD: "ANDORRA",
                AO: "ANGOLA",
                AI: "ANGUILLA",
                AQ: "ANTARCTICA",
                AG: "ANTIGUA &amp; BARBUDA",
                AE: "ARAB EMIRATES",
                AR: "ARGENTINA",
                AP: "ARIPO",
                AM: "ARMENIA",
                AW: "ARUBA",
                AU: "AUSTRALIA",
                AT: "AUSTRIA",
                AZ: "AZERBAIJAN",
                BS: "BAHAMAS",
                BH: "BAHRAIN",
                BD: "BANGLADESH",
                BB: "BARBADOS",
                BY: "BELARUS",
                BE: "BELGIUM",
                BZ: "BELIZE",
                BX: "BENELUX",
                BJ: "BENIN",
                DA: "BENIN",
                BM: "BERMUDA",
                BT: "BHUTAN",
                BO: "BOLIVIA",
                BA: "BOSNIA &amp; HERZEGOV",
                BW: "BOTSWANA",
                BV: "BOUVET ISLAND",
                VG: "BR.VIRGIN ISLANDS",
                BR: "BRAZIL",
                IO: "BRIT IND OCN TERR",
                BN: "BRUNEI DARUSSALAM",
                BG: "BULGARIA",
                BF: "BURKINA FASO",
                UV: "BURKINA FASO",
                BI: "BURUNDI",
                KH: "CAMBODIA",
                CM: "CAMEROON",
                KA: "CAMEROON",
                CA: "CANADA",
                PZ: "CANAL ZONE",
                CV: "CAPE VERDE",
                KY: "CAYMAN ISLANDS",
                CF: "CENT AFRICAN REP",
                TD: "CHAD",
                TS: "CHAD",
                CE: "CHILE",
                CL: "CHILE",
                CN: "CHINA",
                RC: "CHINA",
                CX: "CHRISTMAS ISLAND",
                CC: "COCOS/KEELING ISL",
                CO: "COLOMBIA",
                KM: "COMOROS",
                CG: "CONGO",
                CK: "COOK ISLANDS",
                CR: "COSTA RICA",
                CI: "COTE D'IVOIRE",
                HR: "CROATIA",
                CU: "CUBA",
                CY: "CYPRUS",
                CZ: "CZECH REPUBLIC",
                CS: "CZECHOSLOVAKIA",
                CB: "DEM REP OF CONGO",
                CD: "DEM REP OF CONGO",
                KP: "DEM REP OF KOREA",
                YD: "DEMOCRATIC YEMEN",
                DK: "DENMARK",
                DJ: "DJIBOUTI",
                DM: "DOMINICA",
                DO: "DOMINICAN REP",
                DR: "DOMINICAN REP",
                TP: "EAST TIMOR",
                EC: "ECUADOR",
                EG: "EGYPT",
                SV: "EL SALVADOR",
                EP: "EPO",
                GQ: "EQUATORIAL GUINEA",
                ER: "ERITREA",
                EM: "ERPN CMNTY TM OFC",
                EE: "ESTONIA",
                ET: "ETHIOPIA",
                EA: "EURASIAN PO",
                FK: "FALKLAND ISLANDS",
                FO: "FAROE ISLANDS",
                DE: "FED REP GERMANY",
                DT: "FED REP GERMANY",
                KV: "FED ST KITTS/NEVIS",
                FJ: "FIJI",
                FI: "FINLAND",
                SF: "FINLAND",
                TF: "FR.SO./ANTARCTIC",
                FR: "FRANCE",
                FX: "FRANCE METROPOLTN",
                GF: "FRENCH GUIANA",
                PF: "FRENCH POLYNESIA",
                GA: "GABON",
                GM: "GAMBIA",
                GC: "GCC PATEN OFFICE",
                DD: "GERMAN DEM REP",
                DL: "GERMAN DEM REP",
                GH: "GHANA",
                GI: "GIBRALTAR",
                GR: "GREECE",
                GL: "GREENLAND",
                GD: "GRENADA",
                GP: "GUADELOUPE",
                GU: "GUAM",
                GT: "GUATEMALA",
                GG: "GUERNSEY",
                GN: "GUINEA",
                GW: "GUINEA-BISSAU",
                GY: "GUYANA",
                XH: "HAGUE",
                HI: "HAITI",
                HT: "HAITI",
                HM: "HEARD/MCDONALD IS",
                HN: "HONDURAS",
                HO: "HONDURAS",
                HK: "HONG KONG",
                HU: "HUNGARY",
                IS: "ICELAND",
                IB: "IIB",
                IN: "INDIA",
                ID: "INDONESIA",
                IR: "IRAN",
                IQ: "IRAQ",
                EI: "IRELAND",
                IE: "IRELAND",
                IL: "ISRAEL",
                IT: "ITALY",
                JM: "JAMAICA",
                JA: "JAPAN",
                JP: "JAPAN",
                JE: "JERSEY",
                JT: "JOHNSTON ATOLL",
                JO: "JORDAN",
                KZ: "KAZAKHSTAN",
                KE: "KENYA",
                KI: "KIRIBATI",
                KU: "KUWAIT",
                KW: "KUWAIT",
                KG: "KYRGYZSTAN",
                LA: "LAO PEOPL DEM REP",
                LV: "LATVIA",
                LB: "LEBANON",
                LS: "LESOTHO",
                LR: "LIBERIA",
                LY: "LIBYA",
                FL: "LIECHTENSTEIN",
                LI: "LIECHTENSTEIN",
                LT: "LITHUANIA",
                LU: "LUXEMBOURG",
                MO: "MACAO",
                MK: "MACEDONIA",
                MG: "MADAGASCAR",
                MW: "MALAWI",
                MY: "MALAYSIA",
                MV: "MALDIVES",
                MJ: "MALI",
                ML: "MALI",
                MT: "MALTA",
                MH: "MARSHALL ISLANDS",
                MQ: "MARTINIQUE",
                MR: "MAURITANIA",
                MU: "MAURITIUS",
                YT: "MAYOTTE",
                MX: "MEXICO",
                FM: "MICRONESIA",
                MC: "MONACO",
                MN: "MONGOLIA",
                MS: "MONTSERRAT",
                MA: "MOROCCO",
                MZ: "MOZAMBIQUE",
                BU: "MYANMAR",
                MM: "MYANMAR",
                MP: "N. MARIANA ISLAND",
                NA: "NAMIBIA",
                NR: "NAURU",
                NV: "NAVASSA ISLAND",
                NP: "NEPAL",
                NL: "NETHERLANDS",
                AN: "NETHERLD ANTILLES",
                NT: "NEUTRAL ZONE",
                NC: "NEW CALEDONIA",
                NH: "NEW HEBRIDES",
                NZ: "NEW ZEALAND",
                NI: "NICARAGUA",
                NE: "NIGER",
                NG: "NIGERIA",
                WN: "NIGERIA",
                NU: "NIUE",
                NF: "NORFOLK ISLAND",
                NO: "NORWAY",
                XO: "NOT ON LIST",
                XP: "NOT PROVIDED",
                OA: "OAPI",
                OM: "OMAN",
                ABC: "Other - ALBERTA                    ",
                BCC: "Other - BRITISH COLUMBIA           ",
                GB1: "Other - CHANNEL ISLANDS            ",
                GB2: "Other - ENGLAND                    ",
                USE: "Other - ERDA                       ",
                DE1: "Other - FEDERAL REPUBLIC OF GERMANY",
                GB3: "Other - GREAT BRITAIN              ",
                GB4: "Other - ISLE OF MAN                ",
                MBC: "Other - MANITOBA                   ",
                OM1: "Other - MUSCAT                     ",
                USS: "Other - NASA                       ",
                NBC: "Other - NEW BRUNSWICK              ",
                NFC: "Other - NEWFOUNDLAND               ",
                NLC: "Other - NEWFOUNDLAND/LABR          ",
                GB5: "Other - NORTHERN IRELAND           ",
                NSC: "Other - NOVA SCOTIA                ",
                NUC: "Other - NUNAVUT                    ",
                NTC: "Other - NW TERRITORIES             ",
                ONC: "Other - ONTARIO                    ",
                PEC: "Other - PRINCE EDWARD IS.          ",
                PQC: "Other - QUEBEC                     ",
                SKC: "Other - SASKATCHEWAN               ",
                GB6: "Other - SCOTLAND                   ",
                CN1: "Other - TIBET                      ",
                USF: "Other - U.S. AIR FORCE",
                USA: "Other - U.S. ARMY",
                USN: "Other - U.S. NAVY",
                GB7: "Other - WALES                      ",
                YTC: "Other - YUKON TERRITORY",
                PC: "PACIFIC ISLANDS",
                PK: "PAKISTAN",
                PW: "PALAU",
                PA: "PANAMA",
                PG: "PAPUA NEW GUINEA",
                PP: "PAPUA NEW GUINEA",
                PI: "PARACEL ISLANDS",
                PY: "PARAGUAY",
                XX: "PCT",
                PE: "PERU",
                PH: "PHILIPPINES",
                PN: "PITCAIRN ISLANDS",
                PL: "POLAND",
                PO: "POLAND",
                PT: "PORTUGAL",
                PR: "PUERTO RICO",
                QA: "QATAR",
                GE: "REP OF GEORGIA",
                MD: "REPUBLIC MOLDOVA",
                KR: "REPUBLIC OF KOREA",
                KS: "REPUBLIC OF KOREA",
                RE: "REUNION",
                RO: "ROMANIA",
                RU: "RUSSIAN FED.",
                RW: "RWANDA",
                OO: "SAMOA",
                SM: "SAN MARINO",
                ST: "SAO TOME/PRINCIPE",
                SA: "SAUDI ARABIA",
                SN: "SENEGAL",
                SS: "SERBIA/MONTENEGRO",
                SC: "SEYCHELLES",
                SL: "SIERRA LEONE",
                WL: "SIERRA LEONE",
                SG: "SINGAPORE",
                SK: "SLOVAKIA",
                SI: "SLOVENIA",
                SB: "SOLOMON ISLANDS",
                SO: "SOMALIA",
                ZA: "SOUTH AFRICA",
                GS: "SOUTH GEORGIA",
                RH: "SOUTHERN RHODESIA",
                ES: "SPAIN",
                LK: "SRI LANKA",
                VC: "ST. VINCENT/GRDN",
                KN: "ST.CHRIST-NEVIS",
                SH: "ST.HELENA",
                LC: "ST.LUCIA",
                PM: "ST.PIERRE/MIQUE",
                ZZ: "STATELESS",
                SD: "SUDAN",
                SR: "SURINAME",
                SJ: "SVALBARD/JAN MAY",
                SZ: "SWAZILAND",
                SE: "SWEDEN",
                SW: "SWEDEN",
                CH: "SWITZERLAND",
                SY: "SYRIAN ARAB REP",
                TW: "TAIWAN",
                TJ: "TAJIKISTAN",
                TA: "TANZANIA",
                TZ: "TANZANIA",
                TH: "THAILAND",
                TL: "TIMOR-LESTE",
                TG: "TOGO",
                TK: "TOKELAU ISLANDS",
                TI: "TONGA",
                TO: "TONGA",
                TT: "TRINIDAD/TOBAGO",
                TN: "TUNISIA",
                TR: "TURKEY",
                TM: "TURKMENISTAN",
                TC: "TURKS/CAICOS IS.",
                TV: "TUVALU",
                UM: "U.S. MINOR IS.",
                SU: "U.S.S.R.",
                UG: "UGANDA",
                UA: "UKRAINE",
                GB: "UNITED KINGDOM",
                US: "UNITED STATES",
                HV: "UPPER VOLTA",
                UY: "URUGUAY",
                VI: "US VIRGIN ISLANDS",
                UZ: "UZBEKISTAN",
                VU: "VANUATU",
                VA: "VATICAN CITY",
                VE: "VENEZUELA",
                VN: "VIETNAM",
                WK: "WAKE ISLAND",
                WF: "WALLIS/FUTUNA IS.",
                PS: "WEST BANK/GAZA",
                EH: "WESTERN SAHARA",
                WS: "WESTERN SAMOA",
                WO: "WIPO",
                YE: "YEMEN",
                YU: "YUGOSLAVIA",
                ZR: "ZAIRE",
                ZB: "ZAMBIA",
                ZM: "ZAMBIA",
                ZW: "ZIMBABWE",
            },
            work_owner: {
                party_name: '',
                entity_type: '',
                address_1: '',
                address_2: '',
                country: '',
                city: '',
                state: '',
                zip: '',
                citizenship: '',
            }
        }
    },
    watch: {
        start_owners(){
            this.owners = this.start_owners
        },
        owners: {
            handler:function(newVal) {
                this.$emit('update', newVal)
            },
            deep:true
        },
    },
    methods: {
        edit(index){
            this.run_valid = false
            this.work_owner = JSON.parse(JSON.stringify(this.owners[index]))
            this.work_owner.index = index
            this.showModal = true
        },
        async update(){
            this.run_valid = true
            if (!this.isValid()) {
                return null
            }

            this.showModal = false
            this.owners[this.work_owner.index] = this.work_owner
        },
        async deleteOwner(index){
            const response = confirm('Do you want to delete this owner?')

            if (response) {
                this.owners.splice(index, 1);
            }
        },
        isValid(){
            if (
                !this.work_owner.party_name ||
                (!this.work_owner.address_1 && !this.work_owner.address_2) ||
                !this.work_owner.city ||
                !this.work_owner.entity_type ||
                !this.work_owner.citizenship
            ) {
                return false
            }

            return true
        },
        level_1(owner) {
            let arr = []

            if (owner.address_1 && owner.address_1.length) {
                arr.push(owner.address_1)
            }

            if (owner.address_2 && owner.address_2.length) {
                arr.push(owner.address_2)
            }

            return arr.join(', ')
        },
        level_2(owner) {
            let arr1 = []
            let arr2 = []

            if (owner.city && owner.city.length) {
                arr1.push(owner.city)
            }

            if (owner.state && owner.state.length) {
                arr1.push(owner.state)
            }

            if (owner.zip && owner.zip.length) {
                arr2.push(owner.zip)
            }

            if (owner.country && owner.country.length) {
                arr2.push(owner.country)
            }

            return arr1.join(', ') + ' ' + arr2.join(' ')
        },
    }
}
</script>

<style>
.modal-body-main {
    min-width: 900px;
}
@media only screen and (max-width: 944px) {
    .modal-body-main {
        min-width: auto;
    }
}
</style>
